var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1155.87 126.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .rounded-divider-1 {\n        fill: #fbac46;\n      }\n\n      .rounded-divider-1, .rounded-divider-2, .rounded-divider-3, .rounded-divider-4, .rounded-divider-5, .rounded-divider-6, .rounded-divider-7, .rounded-divider-8 {\n        stroke-width: 0px;\n      }\n\n      .rounded-divider-2 {\n        fill: #799dab;\n      }\n\n      .rounded-divider-3 {\n        fill: #3c5572;\n      }\n\n      .rounded-divider-4 {\n        fill: #e5b989;\n      }\n\n      .rounded-divider-5 {\n        fill: #f79330;\n      }\n\n      .rounded-divider-6 {\n        fill: #f3eb43;\n      }\n\n      .rounded-divider-7 {\n        fill: #fff;\n      }\n\n      .rounded-divider-8 {\n        fill: #edd1b0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Divider_1",
    "data-name": "Rounded Divider 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-7",
    width: 1155.87,
    height: 126.57,
    rx: 33.23,
    ry: 33.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-6",
    x: 167.17,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-1",
    x: 296.37,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-5",
    x: 425.96,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-3",
    x: 555.55,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-2",
    x: 685.14,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-8",
    x: 814.74,
    y: 44.66,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "rounded-divider-4",
    x: 944.33,
    y: 44.66,
    width: 129.59,
    height: 9.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedDivider);
export default __webpack_public_path__ + "static/media/Rounded-Divider.4bc70dcd8bf40e3c250697a4dd1cefeb.svg";
export { ForwardRef as ReactComponent };